import { FunctionComponent } from "react";
import styled from "styled-components";
import { PrimaryButton } from "../../components/button";
import { Icon } from "../../components/icons";
import { CenteredFlex, Flex, FullSize } from "../../components/layout";
import { H1 } from "../../components/typography";

const Container = styled.div`
  ${CenteredFlex};
  ${FullSize};
  flex-direction: column;
  font-size: 3vmin;
  padding: 0 20%;
  text-align: center;
`;

const SadFace = styled(Icon).attrs({ type: "empty" })`
  font-size: 4em;
  margin-top: 1em;
`;

const CTA = styled(PrimaryButton)`
  margin-top: 4em;
`;

export const SystemErrorPage: FunctionComponent<{}> = () => {
  return (
    <Container>
      <H1>Oops... seems like we have encountered an error</H1>
      <SadFace />
      <CTA onClick={() => window.location.reload()}>Reload Page</CTA>
    </Container>
  );
};
